<template>
  <div class="container is-fluid">
    <div class="box has-background-light">
      <h5 class="title is-5 has-text-primary">Balancete</h5>
      <form @submit.prevent="filterRecords" class="filter-form">
        <div class="columns is-multiline is-mobile">
          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Tipo de Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbTipoPeriodo" @change="selectTipoPeriodo()">
                    <option value="0" disabled>Selecione um tipo de período</option>
                    <option v-for="td in tiposPeriodo" :key="td.id" :value="td.id">
                      {{ td.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Perfil</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPerfil" @change="selectPerfil()">
                    <option value="0" disabled>Selecione um perfil</option>
                    <option v-for="perfilUsuario in perfisUsuario" :key="perfilUsuario.id" :value="perfilUsuario.perfil.id">
                      {{ perfilUsuario.perfil.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Período</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbPeriodoPerfil">
                    <option value="0" disabled>Selecione um período</option>
                    <option v-for="periodoPerfil in periodosPerfis" :key="periodoPerfil.id" :value="periodoPerfil.id">
                      {{ periodoPerfil.periodo.descricao }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small">Campo de Pesquisa</label>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="cmbCampoPesquisa">
                    <option value="0">Todas as Contas</option>
                    <option value="1">Conta Contábil</option>
                    <option value="2">Descrição</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-flex-grow-1">
            <div class="field">
              <label class="label is-small">Argumento</label>
              <div class="control">
                <input
                  class="input is-small"
                  type="text"
                  placeholder="Informe o argumento da pesquisa"
                  v-model="txtArgument"
                  :disabled="cmbCampoPesquisa == '0'"
                >
              </div>
            </div>
          </div>

          <div class="column is-narrow">
            <div class="field">
              <label class="label is-small"></label>
              <div class="control">
                <button type="submit" class="button is-primary is-rounded is-small">
                  <span class="icon is-small">
                    <i class="fas fa-filter"></i>
                  </span>
                  <span>Filtrar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="card" v-show="showInfo">
      <header class="card-header has-background-primary has-text-white">
        <p class="card-header-title has-text-white">Resultados do Balancete</p>
      </header>
      <div class="card-content">
        <div class="table-container">
          <table class="table is-striped is-narrow is-hoverable is-fullwidth">
            <thead>
              <tr class="has-background-grey-lighter">
                <th class="is-size-7">Conta</th>
                <th class="is-size-7">Descrição da Conta</th>
                <th class="is-size-7 has-text-centered">Saldo Anterior</th>
                <th class="is-size-7 has-text-centered">Débitos</th>
                <th class="is-size-7 has-text-centered">Créditos</th>
                <th class="is-size-7 has-text-centered">Movimento</th>
                <th class="is-size-7 has-text-centered">Saldo Final</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="balancete in balancetes" :key="balancete.id">
                <td class="is-size-7">{{ balancete.plano_contas.conta_contabil }}</td>
                <td class="is-size-7">{{ balancete.plano_contas.descricao }}</td>
                <td class="is-size-7 has-text-centered">{{ balancete.saldo_anterior | numberFormat }}</td>
                <td class="is-size-7 has-text-centered">{{ balancete.valor_debito | numberFormat }}</td>
                <td class="is-size-7 has-text-centered">{{ balancete.valor_credito | numberFormat }}</td>
                <td class="is-size-7 has-text-centered">{{ balancete.valor_movimento | numberFormat }}</td>
                <td class="is-size-7 has-text-centered">{{ balancete.saldo_final | numberFormat }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <footer class="card-footer">
        <div class="card-footer-item">
          <nav class="pagination is-rounded is-small" role="navigation" aria-label="pagination">
            <a
              class="pagination-previous button is-primary"
              @click="previousPage()"
              :disabled="page == 1 || page == null"
            >
              Anterior
            </a>
            <a
              class="pagination-next button is-primary"
              @click="nextPage()"
              :disabled="page == numpages"
            >
              Próxima
            </a>
          </nav>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { http } from '../../services/config';

export default {
  name: 'Balancete',
  data() {
    return {
      periodosPerfis: [],
      perfisUsuario: [],
      balancetes: [],
      tiposPeriodo: [],
      previous: null,
      next: null,
      page: null,
      numpages: null,
      cmbPerfil: 0,
      cmbPeriodoPerfil: 0,
      cmbCampoPesquisa: 0,
      cmbTipoPeriodo: 0,
      txtArgument: null,
      showInfo: false,
    };
  },
  filters: {
    numberFormat(value) {
      if (!value) return '0,00';
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  methods: {
    nextPage() {
      if (this.page !== this.numpages) {
        http.get(this.next, {
          params: {
            idPeriodoPerfil: this.cmbPeriodoPerfil,
            cmbCampoPesquisa: this.cmbCampoPesquisa,
            txtArgument: this.txtArgument,
          },
        }).then((response) => {
          this.balancetes = response.data.results;
          this.previous = response.data.previous;
          this.next = response.data.next;
          this.page = response.data.page;
          this.numpages = response.data.numpages;
        });
      }
    },
    previousPage() {
      if (this.page !== 1) {
        http.get(this.previous, {
          params: {
            idPeriodoPerfil: this.cmbPeriodoPerfil,
            cmbCampoPesquisa: this.cmbCampoPesquisa,
            txtArgument: this.txtArgument,
          },
        }).then((response) => {
          this.balancetes = response.data.results;
          this.previous = response.data.previous;
          this.next = response.data.next;
          this.page = response.data.page;
          this.numpages = response.data.numpages;
        });
      }
    },
    filterRecords() {
      if (this.cmbPerfil == 0) {
        alert('Selecione um perfil');
        return;
      }
      if (this.cmbPeriodoPerfil == 0) {
        alert('Selecione um período');
        return;
      }
      http.get('balancete/listar/', {
        params: {
          idPeriodoPerfil: this.cmbPeriodoPerfil,
          cmbCampoPesquisa: this.cmbCampoPesquisa,
          txtArgument: this.txtArgument,
        },
      }).then((response) => {
        this.balancetes = response.data.results;
        this.previous = response.data.previous;
        this.next = response.data.next;
        this.page = response.data.page;
        this.numpages = response.data.numpages;
        if (this.balancetes.length) {
          this.showInfo = true;
        } else {
          this.showInfo = false;
          alert('Não há dados associados aos parâmetros informados!');
        }
      });
    },
    selectTipoPeriodo() {
      this.cmbPerfil = 0;
      this.cmbPeriodoPerfil = 0;
      this.cmbCampoPesquisa = 0;
      this.txtArgument = null;
      this.showInfo = false;
    },
    selectPerfil() {
      if (this.cmbTipoPeriodo == 0) {
        alert('Selecione um tipo de período!');
        return;
      }
      http.get('periodoPerfil/listar/', {
        params: {
          idPerfil: this.cmbPerfil,
          idTipoPeriodo: this.cmbTipoPeriodo,
          semPaginacao: 'S',
        },
      }).then((response) => {
        this.periodosPerfis = response.data.results;
        if (!this.periodosPerfis.length) {
          alert('Não há períodos associados ao perfil selecionado!');
          this.cmbPeriodoPerfil = 0;
        }
      });
    },
  },
  mounted() {},
  created() {
    http.get('compartilharPerfis/listarPerfis').then((response) => {
      this.perfisUsuario = response.data.results;
    });
    http.get('tiposPeriodo/listar').then((response) => {
      this.tiposPeriodo = response.data.results;
    });
  },
};
</script>

<style scoped>
</style>